import { FC } from "react";
import { Result } from "antd";

const Maintenance: FC = () => (
  <Result
    status="warning"
    title="Server is under maintenance, please wait a moment"
  />
);

export default Maintenance;
